<template lang="pug">
  app-dialog(v-model="$_show" :header="headerText" :confirm-text="confirmText" :confirm-disabled="isNotReady" @confirm="createGroup")
    .advocatapp
        app-text-field(v-model="form.groupName" label="Название" )
        bankAccountItem(:form.sync="form.bankAccount")

</template>

<script>
import { AppDialogToggable } from '@/components'
import bankAccountItem from './BankAccountItem'

export default {
  mixins: [AppDialogToggable],
  components: {
    bankAccountItem
  },
  props: {
    group: null,
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      groupName: '', 
      bankAccount: {},
    })

    return {
      form: Object.assign({}, defaultForm),
      defaultForm
    }
  },
  methods: {
    createGroup() {
      if(this.form.id==null)
          this.$store.dispatch('specialist/CREATE_GROUP', this.form)
      else
          this.$store.dispatch('specialist/UPDATE_GROUP', this.form)
    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.group || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
  computed: {
    isNotReady () {
      return false
    },
    confirmText() {
      return this.group!=null ? "Редактировать" : "Создать"
    },
    headerText() {
      return this.group!=null ? "Редактировать группу" : "Создать группу"
    },

  },
}
</script>

<style lang="scss" scoped>

</style>

